// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pazq","col":"styles_col__mGzGV","actions":"styles_actions__MAr7B","conflict":"styles_conflict__28Lrj"};